import { AppConfig } from '../../../AppConfig'
import { UploadHelper } from '../../../common/helpers/UploadHelper'

export const LINKEDIN_URLS_MAX = 500

// Anything between pasted LinkedIn URLs is split on these; add or remove entries as needed.
export const LINKEDIN_URL_SEPARATORS = ['\n', '\r', '\t', ' ', '\u00a0', ',', ';', '|']

const SEPARATOR_REGEX = new RegExp(LINKEDIN_URL_SEPARATORS.map((separator) => separator.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|'))
const LINKEDIN_URL_REGEX = /(?:^|[^a-z0-9.-])((?:https?:\/\/)?(?:[a-z0-9-]+\.)*linkedin\.com\/[^\s"'<>()[\]{}]+)/i

export function linkedinUrlsFromText(text) {
  const urls = []
  const seen = {}
  String(text || '').split(SEPARATOR_REGEX).forEach((token) => {
    const match = token.match(LINKEDIN_URL_REGEX)
    if (!match) return
    let url = match[1].replace(/[.,;:!?]+$/, '')
    if (!/^https?:\/\//i.test(url)) url = `https://${url}`
    const key = url.toLowerCase().replace(/^https?:\/\/(www\.)?/, '').replace(/\/+$/, '')
    if (seen[key]) return
    seen[key] = true
    urls.push(url)
  })
  return urls
}

export function linkedinUrlsToCsv(urls) {
  return ['linkedinurl'].concat(urls).join('\n')
}

export async function uploadLinkedinUrlsCsv({ orgId, urls }) {
  const signedUploadInfo = await UploadHelper.fetchUploadUrlAwait(null, {
    uploadLocation: orgId,
    type: 'media',
    ext: 'csv',
    ms: AppConfig.CDP_MS.ENDPOINT,
  })
  await UploadHelper.uploadFormDataAwait({
    signedUploadInfo,
    pickerResult: new File([linkedinUrlsToCsv(urls)], 'linkedin-urls.csv', { type: 'text/csv' }),
  })
  return signedUploadInfo.fields.key
}
